import React from "react";

export const TituloUnidadesConteo = ({ longitud }) => {
  return (
    <div className="row">
      <div className="text-center">
        <h4>
          <strong>Unidades: </strong> {longitud}
        </h4>
      </div>
    </div>
  );
};
